import { render, staticRenderFns } from "./proCreateQz.vue?vue&type=template&id=88067f5c&scoped=true"
import script from "./proCreateQz.vue?vue&type=script&lang=js"
export * from "./proCreateQz.vue?vue&type=script&lang=js"
import style0 from "./proCreateQz.vue?vue&type=style&index=0&id=88067f5c&prod&lang=css"
import style1 from "./proCreateQz.vue?vue&type=style&index=1&id=88067f5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88067f5c",
  null
  
)

export default component.exports